import {EntityLineHeader} from '../entity/entity-line-header';
import {EntityLine} from '../entity/entity-line';
import {Specification} from '../entity/specification';
import {SpecificationCharacteristic} from '../entity/specification-characteristic';
import {StringUtils} from './string-utils';
import {ArrayUtils} from './array-utils';

export class EntityLineUtils {

  static hasDiscontinuedProduct(line: EntityLineHeader): boolean {
    if (!line || !line.product) {
      return false;
    }
    return EntityLineUtils.isDiscontinuedProduct(line.product);
  }

  static isDiscontinuedProduct(productId: string): boolean {
    if (!productId || productId.trim().length === 0) {
      return false;
    }
    const discontinued = ['VerticalFloor', 'VerticalFloorClassic', 'VerticalFloorClassicEH'];
    return discontinued.indexOf(productId) >= 0;
  }

  static getSpecificationCharacteristicValue(entityLine: EntityLine, specificationType: string, key: string): string {
    if (ArrayUtils.isEmpty(entityLine?.singleEntityLines) || StringUtils.isBlank(key) || StringUtils.isBlank(specificationType)) {
      return undefined!;
    }
    const specifications: Specification[] = entityLine.singleEntityLines[0].specifications;
    const characteristics: SpecificationCharacteristic[] = specifications.filter(spec => spec.specificationType === specificationType)
      .flatMap(spec => spec.specificationCharacteristics)
      .filter(spec => key.trim().toLowerCase() === spec.key.trim().toLowerCase());
    if (characteristics.length === 1) {
      return characteristics[0].value;
    }
    return undefined!;
  }

}
